import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BestFinder"] */ "/vercel/path0/src/app/best/BestFinder.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/best/BestIndexPage.module.css");
